import 'graphql-voyager/dist/voyager.css';

import type { ExecutionResult, IntrospectionQuery } from 'graphql';
import { Voyager, voyagerIntrospectionQuery } from 'graphql-voyager';

import { graphQLClient } from './graphqlConfig';

const getIntrospection = async (): Promise<ExecutionResult<IntrospectionQuery>> => {
  const response = await graphQLClient.rawRequest<IntrospectionQuery>(voyagerIntrospectionQuery);
  return response as ExecutionResult<IntrospectionQuery>;
};

export default function GraphQLVoyager() {
  const introspection = getIntrospection();

  return <Voyager introspection={introspection} />;
}
